import React, { useEffect, useState } from "react";
import { isValidArray, capitalizeFirstLetter } from "../../Layout/Common/common";
import { useRefinementList } from "react-instantsearch";
import { v4 as uuidv4 } from "uuid";
import { useDevice } from "../../Context/hook/useDeviceType";

export const FacetFilterLite = React.memo(({ attribute, limit, defaultValue, defaultOpenClass = "" }) => {
  const { items, refine, canToggleShowMore, isShowingMore, searchForItems, isFromSearch, toggleShowMore } =
    useRefinementList({
      attribute: attribute,
      sortBy: ["name:asc", "count:desc"],
      limit: 20,
      showMoreLimit: 200,
      showMore: true,
    });
  const [showAll, setShowAll] = useState(isShowingMore);
  const [container, setContainer] = useState("");
  const [filterAttribute, setFilterAttribute] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [listItems, setListItems] = useState(null);
  const [isOpen, setIsOpen] = useState(String(defaultOpenClass).split(" ").includes("show"));
  const { device } = useDevice();
  const handleChange = (item) => {
    if (selectedItems.includes(item.value)) {
      setSelectedItems(selectedItems.filter((v) => v != item.value));
    } else {
      setSelectedItems([...selectedItems, item.value]);
    }
    refine(item.value);
  };

  useEffect(() => {
    if (defaultValue) {
      refine(defaultValue);
    }
    setContainer(`${String(attribute).split(".").at(-1)}-filters`);
    setFilterAttribute(String(attribute).split(".").at(-1));
    setListItems(items);
    if (isValidArray(items)) {
      var refinedItems = items.filter((item) => item.isRefined == true).map((item) => item.value);
      setSelectedItems(refinedItems);
    }
  }, [items, refine]);

  const handleShowMore = () => {
    toggleShowMore();
    setShowAll(!showAll);
  };
  const searchFilter = (e) => {
    const query = e.target.value.toLowerCase();
    searchForItems(`${query}`);
  };

  useEffect(() => {
    if (!container) return;
    const collapseElement = document.getElementById(container);
    if (!collapseElement) return;

    const handleShow = () => setIsOpen(true);
    const handleHide = () => setIsOpen(false);

    setIsOpen(collapseElement.classList.contains("show"));
    collapseElement.addEventListener("show.bs.collapse", handleShow);
    collapseElement.addEventListener("hide.bs.collapse", handleHide);

    return () => {
      collapseElement.removeEventListener("show.bs.collapse", handleShow);
      collapseElement.removeEventListener("hide.bs.collapse", handleHide);
    };
  }, [container]);

  if (isValidArray(items) || isFromSearch) {
    return (
      <div className="accordion-item border-bottom " key={attribute}>
        <h2 className="accordion-header">
          <button
            className={`accordion-button ${isOpen ? "" : "collapsed"}`.trim()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${container}`}
            aria-expanded={isOpen}
            aria-controls={container}
          >
            {capitalizeFirstLetter(filterAttribute)}
            {isValidArray(selectedItems) && (
              <small className="selectedFilter m-2 mt-0 mb-0">{selectedItems.length}</small>
            )}
          </button>
        </h2>
        <div
          id={container}
          className={`accordion-collapse collapse ${defaultOpenClass}`.trim()}
          data-bs-parent={`${device != "desktop" ? "#facetFilterMobile" : "#filterAccordion"}`}
        >
          <div className="accordion-body">
            <div className="filter-selection-wrapper">
              <div className="filterSelection-list">
                <div className="form-input">
                  <input
                    type="text"
                    className="form-control search-brand"
                    placeholder="Search"
                    onChange={searchFilter}
                  />
                </div>
                <div className="filterSelection-listInner mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {isValidArray(listItems) ? (
                    listItems.map((item) => {
                      var uinqueId = uuidv4();
                      return (
                        <div className="form-check custom-check" key={item.label}>
                          <div className="signature-req-input">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={uinqueId}
                              checked={selectedItems.includes(item.value)}
                              onChange={() => handleChange(item)}
                            />
                          </div>
                          <label className="form-check-label form-check-color" htmlFor={uinqueId}>
                            {["color", "colour"].includes(filterAttribute.toLowerCase()) && (
                              <ColorValue color={item.label} />
                            )}
                            {item.label}
                            <span className="product-count">({item.count})</span>
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <p>No search results found</p>
                  )}
                </div>
                {/* Collapse Filters */}
                <div className="filterSelection-collapse">
                  {canToggleShowMore && (
                    <a
                      className="text-decoration-underline collapseMore"
                      data-bs-toggle="collapse"
                      href="#collapseManufacture"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBrand"
                      onClick={handleShowMore}
                    >
                      {showAll ? "Show Less" : "Show More"}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

const ColorValue = ({ color }) => {
  const [hexValue, setHexValue] = useState(color);
  useEffect(() => {}, [color]);
  return <span className="product-color" style={{ backgroundColor: hexValue }}></span>;
};
